import { useEffect, useReducer } from 'react';

export const ACTIONS = {
    OPEN: 'open',
    CLOSE: 'close',
    IDLE: 'idle',
};

export const STATES = {
    OPEN: 'open',
    CLOSED: 'closed',
    IDLE: 'idle',
};

const initialState = {
    currentState: STATES.IDLE,
    refocusTarget: null,
};

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.OPEN:
            return {
                currentState: STATES.OPEN,
                refocusTarget: action.refocusTarget,
            };
        case ACTIONS.CLOSE:
            return {
                currentState: STATES.CLOSED,
                refocusTarget: state.refocusTarget,
            };
        case ACTIONS.IDLE:
            return initialState;
        default:
            throw new Error(
                `modalTriggerReducer: ${action.type} is not a valid action type`
            );
    }
}

export default function useModalTrigger() {
    const [state, dispatch] = useReducer(reducer, initialState);

    function open(refocusTarget) {
        dispatch({ type: ACTIONS.OPEN, refocusTarget });
    }

    function close() {
        dispatch({ type: ACTIONS.CLOSE });
    }

    useEffect(() => {
        if (state.currentState === STATES.CLOSED) {
            if (state.refocusTarget) {
                setTimeout(() => {
                    state.refocusTarget.focus();
                }, 500);
            }
            dispatch({ type: ACTIONS.IDLE });
        }
    }, [state.currentState, state.refocusTarget]);

    return [state.currentState, open, close];
}
